import React from 'react'

const InformeServicioCivil = () => {
  return (
    <div>InformeServicioCivil</div>
  )
}

export default InformeServicioCivil